import { React, useEffect, useState } from "react";
import { Link, NavLink} from "react-router-dom";
import { ReactComponent as GithubIcon } from "../img/icons/gh-icon.svg";
import { ReactComponent as LinkedInIcon } from "../img/icons/linkedin-icon.svg";
import "../style.scss";

function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    // // const menu = document.querySelector(".hamburger");
    // // const links = document.querySelectorAll(".nav-links li");

    // // menu.addEventListener('click', function() {
    // //   setMenuOpen(prev => !prev)

    // //
    // }
    // );

    const handleScroll = (event) => {
      document
        .querySelector("nav")
        .classList.toggle("scroll", window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const linksToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <nav className="nav">
      <div className="nav__inner">
        <div className="logo">
          <h4>
            <Link to="/" exact="true">
              etchng <span>.</span>
            </Link>
          </h4>
        </div>
        {/* <Menu /> */}

        <div
          className={`hamburger ${menuOpen ? "toggle" : ""}`}
          onClick={linksToggle}
        >
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
        </div>

        <ul className={`nav__links ${menuOpen ? "open" : ""}`}>
          <div className="logo" onClick={linksToggle}>
            <h4>
              <Link to="/" exact="true">
                etchng <span>.</span>
              </Link>
            </h4>
          </div>
          {/* <ul className="nav__links"> */}
          <li className={`${menuOpen ? "fade" : ""}`} onClick={linksToggle}>
            <NavLink to="/work">WORK</NavLink>
          </li>
          <li className={`${menuOpen ? "fade" : ""}`} onClick={linksToggle}>
            <NavLink to="/about">ABOUT</NavLink>
          </li>
          <li className={`${menuOpen ? "fade" : ""}`} onClick={linksToggle}>
            <NavLink to="/contact">CONTACT</NavLink>
          </li>
          <li className={`${menuOpen ? "fade" : ""}`} onClick={linksToggle}>
          <div className="social">
          <a
        href="https://github.com/etchng"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="icon gh">
          <GithubIcon />
        </div>
      </a>

      <a
        href="https://www.linkedin.com/in/eric-chung-456ab38a/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="icon in">
          <LinkedInIcon />
        </div>
      </a>
          </div>          </li>


          
        </ul>
      </div>
    </nav>
  );
}

export default Nav;
